import React from 'react';
import { activeProject } from '../../data/mockData';
import CameraFrame from '../../components/ui/CameraFrame';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiDownload, FiMaximize2 } = FiIcons;

const Moodboard = () => {
  return (
    <div className="space-y-6 animate-in fade-in duration-500">
       <div className="flex justify-between items-center mb-6 border-b border-[#222] pb-4">
        <h3 className="font-mono text-lg text-white tracking-widest uppercase">Visual References</h3>
        <div className="flex gap-2">
          <button className="p-2 border border-[#333] text-[#888] hover:text-white hover:border-[#555] transition-colors">
            <SafeIcon icon={FiDownload} />
          </button>
          <button className="px-4 py-2 bg-[#222] border border-[#333] text-white font-mono text-xs uppercase hover:bg-[#333] transition-colors">
            Upload Media
          </button>
        </div>
      </div>

      <div className="columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6">
        {activeProject.moodboard.map((img, index) => (
          <div key={index} className="break-inside-avoid">
            <CameraFrame className="group cursor-pointer">
              <div className="relative overflow-hidden bg-[#111]">
                <img 
                  src={img} 
                  alt={`Moodboard ${index}`} 
                  className="w-full h-auto object-cover opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-all duration-700 ease-out filter grayscale group-hover:grayscale-0"
                />
                
                {/* Overlay UI on hover */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-4">
                  <div className="flex justify-between items-center">
                    <span className="font-mono text-[10px] text-pink-500 tracking-widest uppercase">REF_{index + 1}</span>
                    <button className="text-white hover:text-pink-500 transition-colors">
                      <SafeIcon icon={FiMaximize2} className="w-4 h-4" />
                    </button>
                  </div>
                </div>

                {/* Crosshairs */}
                <div className="absolute inset-0 pointer-events-none opacity-0 group-hover:opacity-30 transition-opacity duration-300 flex items-center justify-center">
                   <div className="w-full h-[1px] bg-pink-500 absolute top-1/2"></div>
                   <div className="w-[1px] h-full bg-pink-500 absolute left-1/2"></div>
                </div>
              </div>
            </CameraFrame>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Moodboard;